import { render } from "./WCInvisibleRecaptcha.vue?vue&type=template&id=44514e6c"
import script from "./WCInvisibleRecaptcha.vue?vue&type=script&lang=js"
export * from "./WCInvisibleRecaptcha.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__